import PropTypes from "prop-types";

const createGradientPropTypes = {
  color1: PropTypes.string.isRequired,
  color2: PropTypes.string.isRequired,
};
createGradient.prototype = createGradientPropTypes;

function createGradient(color1, color2) {
  return `linear-gradient(to right, ${color1}, ${color2})`;
}
function createRadialGradient(color1, color2, color3) {
  return `radial-gradient(${color1}, ${color2}, ${color3})`;
}

export const ColorSchemaPropTypes = PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error"]);

// SETUP COLORS
export const PRIMARYLIGHT = {
  main: "#07657F",
  light: "#71778E",
  dark: "#032B36",
};

export const SECONDARYLIGHT = {
  main: "#6D58E8",
  light: "#D8D8F3",
  dark: "#3E3DAF",
};

export const PRIMARYDARK = {
  main: "#29C7A7",
  light: "#5FDEC4",
  dark: "#1C8872",
};

export const SECONDARYDARK = {
  main: "#E45127",
  light: "#F79174",
  dark: "#C7340B",
};

export const LINK = {
  main: "#0066FF",
  light: "#4D94FF",
  dark: "#0047B3",
};
export const INFO = {
  main: "#34CCFF",
  light: "#81DFFF",
  dark: "#00ADE7",
};
export const SUCCESS = {
  main: "#62CF1B",
  light: "#8BE84F",
  dark: "#428B12",
};
export const WARNING = {
  main: "#EAB308",
  light: "#F6D753",
  dark: "#A68909",
};
export const ERROR = {
  main: "#FD273D",
  light: "#FE7381",
  dark: "#D60218",
};

export const DEFAULT = {
  main: "#FF4D00",
  light: "#FF8458",
  dark: "#E63F00",
};

export const GREY = {
  light: {
    gb: "#FFFFFF",
    gs: "#F2F5F8",
    g7: "#F4F5F6",
    g6: "#DEE0E5",
    g5: "#C8CBD3",
    g4: "#B3B6C2",
    g3: "#9DA1B1",
    g2: "#878C9F",
    gm: "#71778E",
  },
  dark: {
    gb: "#1F2024",
    gs: "#141519",
    g7: "#09090B",
    g6: "#1A1B21",
    g5: "#2C2E36",
    g4: "#3D404C",
    g3: "#4E5262",
    g2: "#606578",
    gm: "#71778E",
  },
};

export const GRADIENTS = {
  primary: createGradient(PRIMARYLIGHT.light, PRIMARYLIGHT.main),
  secondary: createGradient("#0663FA", "#3BD18C"),
  radialLight: createRadialGradient("#0663FA", "rgba(59, 209, 140, 0.12)", "#fff"),
  radialDark: createRadialGradient("#0663FA", "rgba(59, 209, 140, 0.12)", "#1F2024"),
  info: createGradient(INFO.light, INFO.main),
  success: createGradient(SUCCESS.light, SUCCESS.main),
  warning: createGradient(WARNING.light, WARNING.main),
  error: createGradient(ERROR.light, ERROR.main),
};

export const CHART_COLORS = {
  violet: ["#826AF9", "#9E86FF", "#D0AEFF", "#F7D2FF"],
  blue: ["#0066FF", "#34CCFF", "rgba(52, 204, 255, 0.16)", "rgba(0, 102, 255, 0.16)"],
  green: ["#62CF1B", "#60F1C8", "#A4F7CC", "rgba(98, 207, 27, 0.12)"],
  yellow: ["#EAB308", "#FFEF5A", "#FFF7AE", "rgba(234, 179, 8, 0.16)"],
  red: ["#FF6C40", "#FF8F6D", "#FFBD98", "#FFF2D4"],
};

const COMMON = {
  common: { black: "#000", white: "#fff" },

  info: { ...INFO, contrastText: "#fff" },
  link: { ...LINK, contrastText: "#fff" },
  success: { ...SUCCESS, contrastText: "#fff" },
  warning: { ...WARNING, contrastText: "#fff" },
  error: { ...ERROR, contrastText: "#fff" },
  default: { ...DEFAULT, contrastText: "#fff" },
  grey: { ...GREY },
  gradients: GRADIENTS,
  chart: CHART_COLORS,
};

const palette = {
  light: {
    ...COMMON,

    mode: "light",

    primary: { ...PRIMARYLIGHT, contrastText: "#fff" },
    secondary: { ...SECONDARYLIGHT, contrastText: "#fff" },
    grey: { ...GREY.light },

    text: {
      primary: "#09090b",
      secondary: "#606578",
      tertiary: "#626264",
      caption: "#878C9F",
      title: "#9E9E9E",
      icon: "#494949",
      pink: "#f02867",
      green: "#1cb561",
    },
  },
  dark: {
    ...COMMON,

    mode: "dark",

    primary: { ...PRIMARYDARK, contrastText: "#fff" },
    secondary: { ...SECONDARYDARK, contrastText: "#fff" },
    grey: { ...GREY.dark },

    text: {
      primary: "#ffffff",
      secondary: "#878C9F",
      tertiary: "#626264",
      caption: "#606578",
      title: "#9E9E9E",
      icon: "#494949",
      pink: "#f02867",
      green: "#1cb561",
    },
  },
};

export default palette;
